import {useCallback} from 'react';
import {useLocation} from 'react-router-dom';
import {SEARCH_MIN_CHARS} from 'ff-common';
import {useSidePanelPanier} from '@/components/SidePanelPanier/SidePanelPanierContext';
import {useSearch} from '@/components/Navbar/Searchbar/SearchContext';

/**
 * Action du bouton panier de la navbar : bascule le side panel, sauf sur la page
 * panier où il ferait doublon avec le contenu de la page.
 *
 * Exception : tant que la recherche live est active, elle recouvre la page,
 * donc le side panel redevient le seul moyen de consulter son panier.
 */
export const useBasculerSidePanelPanier = (): (() => void) => {
  const {toggle} = useSidePanelPanier();
  const {liveTerm} = useSearch();
  const {pathname} = useLocation();

  const estSurLaPagePanier = pathname.includes('/panier');
  const rechercheActive = liveTerm.length >= SEARCH_MIN_CHARS;

  return useCallback(() => {
    if (estSurLaPagePanier && !rechercheActive) return;
    toggle();
  }, [estSurLaPagePanier, rechercheActive, toggle]);
};
